/**
 * The admin's second factor (TOTP). The admin functions refuse a session below
 * aal2 (supabase/functions/_shared/admin-aal.ts); AdminRoute uses this to pick
 * the screen before any admin page loads.
 */
export type MfaStep = "ok" | "enroll" | "verify";

/** aal2 → in; a verified authenticator but an aal1 session → code; none yet → set one up. */
export function mfaStep(currentLevel: string | null | undefined, verifiedTotp: number): MfaStep {
  if (currentLevel === "aal2") return "ok";
  return verifiedTotp > 0 ? "verify" : "enroll";
}

/**
 * Supabase returns the QR code as `data:image/svg+xml;utf-8,<svg…>` with the
 * SVG unescaped; an <img> needs it percent-encoded.
 */
export function qrImageSrc(qr: string): string {
  const comma = qr.indexOf(",");
  const svg = qr.startsWith("data:") && comma > 0 ? qr.slice(comma + 1) : qr;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

/** Fired when an admin function answers MFA_REQUIRED; AdminRoute shows the code prompt. */
export const MFA_REQUIRED_EVENT = "zettl:admin-mfa-required";

export function isTotpCode(code: string): boolean {
  return /^\d{6}$/.test(code);
}
